// extracted by mini-css-extract-plugin
export var description = "styles-module__description___MoVS8";
export var showMore = "styles-module__showMore___j9d1U";